import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { useLayoutContext } from '../../providers/LayoutProvider';
import { createArticlePreviewCards } from '../../shared/createArticlePreviewCards';
import { ReachButton } from '../ReachButton/ReachButton';
import { AccentedText } from '../AccentedText/AccentedText';
import './RecommendedArticles.scss';

export const RecommendedArticles = ({ node }) => {
    const { quizResults } = useLayoutContext();
    const {
        allNodeArticle: { nodes: articles },
    } = useStaticQuery(graphql`
        query {
            allNodeArticle(
                sort: {
                    relationships: {
                        field_summary: { field_publish_date: DESC }
                    }
                }
            ) {
                nodes {
                    id
                    fields {
                        url
                    }
                    relationships {
                        field_summary {
                            field_article_title
                            field_subtitle
                            relationships {
                                field_category {
                                    name
                                }
                                field_image {
                                    field_media_image {
                                        alt
                                    }
                                    relationships {
                                        field_media_image {
                                            localFile {
                                                childImageSharp {
                                                    ...ImageConstrainedOneHalfSettings
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    let matches = articles.slice(1, 4);

    if (quizResults?.goal) {
        matches = articles.filter(
            (article) =>
                article.relationships?.field_summary?.relationships?.field_category?.name
                    .toLowerCase()
                    .replaceAll(` `, ``) ===
                quizResults.goal.toLowerCase().replaceAll(` `, ``)
        );
        matches = matches.slice(0, 3);
        for (
            let i = matches.length;
            i < articles.length - 1 && matches.length < 3;
            i++
        ) {
            if (!matches.find((match) => match.id === articles[i].id)) {
                matches.push(articles[i]);
            }
        }
    }

    return (
        <section
            className={`c--rec-articles ${
                node.field_dark_mode ? `dark` : `light`
            } themed-container`}
        >
            <div className="kite-container">
                <h2 className="typestack-title-3">
                    <span>
                        <AccentedText>{node.field_heading}</AccentedText>
                    </span>
                    <ReachButton href="/learn" buttonStyle="secondary">
                        View All Articles
                    </ReachButton>
                </h2>
                <div className="articles">
                    {createArticlePreviewCards(matches, true)}
                </div>
            </div>
        </section>
    );
};
